import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col, Card, Table, Button, Form, InputGroup, Badge, Spinner, Modal, Nav, Pagination } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { getApiUrl } from '../config/api';
const DataPenunjang = () => {
  const navigate = useNavigate();

  // ── State Jam & Tanggal Realtime ──
  const [time, setTime] = useState({ date: '', clock: '' });

  // ── State Data Tindakan Lab (/show_tindakan_lab) ──
  const [tindakanLabList, setTindakanLabList] = useState([]);
  const [isLoading, setIsLoading]             = useState(false);
  const [fetchError, setFetchError]           = useState(null);

  // ── State Tabs & Filtering ──
  const [activeMainTab, setActiveMainTab]     = useState('lab'); // 'lab', 'radiologi', 'fisio', 'pa'
  const [activeJenisTab, setActiveJenisTab]   = useState('ALL'); // 'ALL' or specific nmjenis
  const [activePaketFilter, setActivePaketFilter] = useState('ALL'); // 'ALL', 'PAKET', 'NON_PAKET'
  const [searchQuery, setSearchQuery]         = useState('');
  const [currentPage, setCurrentPage]         = useState(1);
  const [itemsPerPage, setItemsPerPage]       = useState(10);

  // ── State Modal Detail & Tambah ──
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedTindakan, setSelectedTindakan] = useState(null);
  const [showAddModal, setShowAddModal]       = useState(false);
  const [formData, setFormData]               = useState({
    kdjns: '',
    kode: '',
    nmjenis: 'AUTOIMMUNE',
    nmtindakan: ''
  });
  const [formFeedback, setFormFeedback]       = useState(null);

  // ── State Modal Isi Paket Lab ──
  const [showPaketModal, setShowPaketModal] = useState(false);
  const [selectedPaketItem, setSelectedPaketItem] = useState(null);
  const [isiPaketData, setIsiPaketData] = useState([]);
  const [isLoadingPaket, setIsLoadingPaket] = useState(false);

  // Mock initial data sesuai spec response backend /show_tindakan_lab
  const mockTindakanLabData = [
    {
      "kdjns": "001",
      "kode": "00537",
      "loinc_code": "",
      "nilainormal": "< 12.0 GPL-U/mL",
      "nm_paket": "Sesuai Nama Pemeriksaan",
      "nmjenis": "AUTOIMMUNE",
      "nmtindakan": "ACA IgG (Elisa)",
      "paket": 0,
      "satuan": "IU/mL"
    },
    {
      "kdjns": "001",
      "kode": "00538",
      "loinc_code": null,
      "nilainormal": "< 12.0 MPL-U/mL",
      "nm_paket": "Rincian Tersendiri",
      "nmjenis": "AUTOIMMUNE",
      "nmtindakan": "ACA IgM (Elisa)",
      "paket": 0,
      "satuan": "MPL-U/mL"
    },
    {
      "kdjns": "029",
      "kode": "00657",
      "loinc_code": "1940-9",
      "nilainormal": "0 - 10 U/L",
      "nm_paket": "Sesuai",
      "nmjenis": "TUMOR MARKER",
      "nmtindakan": "Acid Phospatase / ACP",
      "paket": 0,
      "satuan": "U/L"
    },
    {
      "kdjns": "001",
      "kode": "00539",
      "loinc_code": "5048-4",
      "nilainormal": "< 1:160 Negative",
      "nm_paket": "Sesuai Nama Pemeriksaan",
      "nmjenis": "AUTOIMMUNE",
      "nmtindakan": "ANA (Antinuclear Antibody)",
      "paket": 0,
      "satuan": "Titer"
    },
    {
      "kdjns": "012",
      "kode": "00120",
      "loinc_code": "57021-8",
      "nilainormal": "P: 13-17 g/dL, W: 12-15 g/dL",
      "nm_paket": "Paket Darah Rutin",
      "nmjenis": "HEMATOLOGI",
      "nmtindakan": "Darah Lengkap (DL) / CBC",
      "paket": 1,
      "satuan": "g/dL"
    },
    {
      "kdjns": "012",
      "kode": "00121",
      "loinc_code": "26464-8",
      "nilainormal": "P: < 15, W: < 20 mm/jam",
      "nm_paket": "Rincian Tersendiri",
      "nmjenis": "HEMATOLOGI",
      "nmtindakan": "Laju Endap Darah (LED)",
      "paket": 0,
      "satuan": "mm/jam"
    },
    {
      "kdjns": "015",
      "kode": "00201",
      "loinc_code": "1558-6",
      "nilainormal": "70 - 110 mg/dL",
      "nm_paket": "Sesuai Nama Pemeriksaan",
      "nmjenis": "KIMIA KLINIK",
      "nmtindakan": "Glukosa Darah Puasa (GDP)",
      "paket": 0,
      "satuan": "mg/dL"
    },
    {
      "kdjns": "015",
      "kode": "00202",
      "loinc_code": "1521-4",
      "nilainormal": "< 140 mg/dL",
      "nm_paket": "Sesuai Nama Pemeriksaan",
      "nmjenis": "KIMIA KLINIK",
      "nmtindakan": "Glukosa Darah 2 Jam PP",
      "paket": 0,
      "satuan": "mg/dL"
    },
    {
      "kdjns": "029",
      "kode": "00658",
      "loinc_code": "1834-4",
      "nilainormal": "< 10.0 ng/mL",
      "nm_paket": "Sesuai",
      "nmjenis": "TUMOR MARKER",
      "nmtindakan": "Alpha Fetoprotein (AFP)",
      "paket": 0,
      "satuan": "ng/mL"
    },
    {
      "kdjns": "029",
      "kode": "00659",
      "loinc_code": "2039-6",
      "nilainormal": "< 5.0 ng/mL",
      "nm_paket": "Sesuai",
      "nmjenis": "TUMOR MARKER",
      "nmtindakan": "CEA (Carcinoembryonic Antigen)",
      "paket": 0,
      "satuan": "ng/mL"
    }
  ];

  // Mock initial data Radiologi sesuai spec response backend /show_tindakan_rad
  const mockTindakanRadData = [
    {
      "kode": "00055",
      "nmjenis": "TANPA KONTRAS",
      "nmtindakan": "Abdomen 3 Posisi"
    },
    {
      "kode": "00054",
      "nmjenis": "TANPA KONTRAS",
      "nmtindakan": "Abdomen AP/BNO"
    },
    {
      "kode": "00060",
      "nmjenis": "TANPA KONTRAS",
      "nmtindakan": "Ankle AP-LAT"
    },
    {
      "kode": "00061",
      "nmjenis": "TANPA KONTRAS",
      "nmtindakan": "Thorax PA / AP"
    },
    {
      "kode": "00070",
      "nmjenis": "DENGAN KONTRAS",
      "nmtindakan": "Colon In Loop"
    },
    {
      "kode": "00085",
      "nmjenis": "CT-SCAN",
      "nmtindakan": "CT-Scan Kepala Non Kontras"
    },
    {
      "kode": "00092",
      "nmjenis": "USG",
      "nmtindakan": "USG Abdomen Upper & Lower"
    }
  ];

  // ── State Data Radiologi (/show_tindakan_rad) ──
  const [tindakanRadList, setTindakanRadList]       = useState([]);
  const [isLoadingRad, setIsLoadingRad]             = useState(false);
  const [activeRadJenisTab, setActiveRadJenisTab]   = useState('ALL');

  // ── State Master Jenis / Kategori dari Endpoint Backend (/jenis_tindakan_lab & /jenis_tindakan_rad) ──
  const [masterJenisLabList, setMasterJenisLabList] = useState(['AUTOIMMUNE', 'TUMOR MARKER', 'HEMATOLOGI', 'KIMIA KLINIK']);
  const [masterJenisRadList, setMasterJenisRadList] = useState(['TANPA KONTRAS', 'DENGAN KONTRAS', 'CT-SCAN', 'USG', 'MRI']);

  // ── Fetch Data Backend /show_tindakan_lab (Pengecekan Komprehensif Payload & Respon) ──
  const fetchTindakanLab = useCallback(async () => {
    setIsLoading(true);
    setFetchError(null);
    const apiUrl = getApiUrl();

    try {
      let res;
      try {
        res = await fetch(`${apiUrl}/show_tindakan_lab`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({})
        });
      } catch {
        res = await fetch(`${apiUrl}/show_tindakan_lab`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        });
      }

      if (!res.ok) throw new Error(`HTTP error ${res.status}`);
      const json = await res.json();

      // Extractor universal yang sangat agresif untuk mendukung semua format wrapper respon backend
      const rawList =
        json?.list_tindakan_lab ||
        json?.data?.list_tindakan_lab ||
        json?.data ||
        json?.tindakan_lab ||
        json?.response ||
        json?.result ||
        json?.list ||
        (Array.isArray(json) ? json : null);

      if (rawList && Array.isArray(rawList) && rawList.length > 0) {
        // Normalisasi field key casing agar seluruh data tampil sempurna di tabel
        const normalizedList = rawList.map(item => ({
          kdjns: item.kdjns || item.kd_jns || item.kd_jenis || '000',
          kode: item.kode || item.kd_tindakan || item.kd_tindakan_lab || '-',
          loinc_code: item.loinc_code || item.kode_loinc || '',
          nilainormal: item.nilainormal || item.nilai_normal || item.nilairujukan || null,
          nm_paket: item.nm_paket || item.nama_paket || '',
          nmjenis: item.nmjenis || item.nm_jenis || item.nama_jenis || 'UMUM',
          nmtindakan: item.nmtindakan || item.nm_tindakan || item.nama_tindakan || '-',
          paket: (String(item.paket) === '1' || String(item.is_paket) === '1' || String(item.paket) === 'true') ? 1 : 0,
          satuan: item.satuan || item.satuan_hasil || null
        }));
        setTindakanLabList(normalizedList);
      } else {
        setTindakanLabList(mockTindakanLabData);
      }
    } catch (err) {
      console.warn('Backend /show_tindakan_lab offline, menggunakan data penunjang:', err);
      setTindakanLabList(mockTindakanLabData);
    } finally {
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ── Fetch Data Backend /show_tindakan_rad ──
  const fetchTindakanRad = useCallback(async () => {
    setIsLoadingRad(true);
    const apiUrl = getApiUrl();

    try {
      let res;
      try {
        res = await fetch(`${apiUrl}/show_tindakan_rad`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({})
        });
      } catch {
        res = await fetch(`${apiUrl}/show_tindakan_rad`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        });
      }

      if (!res.ok) throw new Error(`HTTP error ${res.status}`);
      const json = await res.json();

      // Extractor universal yang sangat agresif untuk mendukung semua format wrapper respon backend
      const rawRadList =
        json?.list_tindakan_rad ||
        json?.data?.list_tindakan_rad ||
        json?.data ||
        json?.tindakan_rad ||
        json?.response ||
        json?.result ||
        json?.list ||
        (Array.isArray(json) ? json : null);

      if (rawRadList && Array.isArray(rawRadList) && rawRadList.length > 0) {
        const normalizedRadList = rawRadList.map(item => ({
          kode: item.kode || item.kd_tindakan || '-',
          nmjenis: item.nmjenis || item.nm_jenis || item.nama_jenis || 'UMUM',
          nmtindakan: item.nmtindakan || item.nm_tindakan || item.nama_tindakan || '-'
        }));
        setTindakanRadList(normalizedRadList);
      } else {
        setTindakanRadList(mockTindakanRadData);
      }
    } catch (err) {
      console.warn('Backend /show_tindakan_rad offline, menggunakan data penunjang radiologi:', err);
      setTindakanRadList(mockTindakanRadData);
    } finally {
      setIsLoadingRad(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ── Fetch Data Backend /jenis_tindakan_lab & /jenis_tindakan_rad ──
  const fetchJenisTindakan = useCallback(async () => {
    const apiUrl = getApiUrl();

    // Fetch Jenis Lab (/jenis_tindakan_lab)
    try {
      let resLab;
      try {
        resLab = await fetch(`${apiUrl}/jenis_tindakan_lab`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({})
        });
      } catch {
        resLab = await fetch(`${apiUrl}/jenis_tindakan_lab`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        });
      }

      if (resLab.ok) {
        const jsonLab = await resLab.json();
        // Extractor universal yang sangat agresif untuk mendukung semua format wrapper respon backend
        const rawLabJenis =
          jsonLab?.list_jenis_tindakan_lab ||
          jsonLab?.data?.list_jenis_tindakan_lab ||
          jsonLab?.data ||
          jsonLab?.jenis_tindakan_lab ||
          jsonLab?.response ||
          jsonLab?.result ||
          jsonLab?.list ||
          (Array.isArray(jsonLab) ? jsonLab : null);

        if (rawLabJenis && Array.isArray(rawLabJenis) && rawLabJenis.length > 0) {
          const names = rawLabJenis.map(j => typeof j === 'string' ? j : j.nmjenis || j.nm_jenis || j.nama_jenis || j.kategori).filter(Boolean);
          if (names.length > 0) setMasterJenisLabList(names);
        }
      }
    } catch (err) {
      console.warn('Endpoint /jenis_tindakan_lab offline:', err);
    }

    // Fetch Jenis Radiologi (/jenis_tindakan_rad)
    try {
      let resRad;
      try {
        resRad = await fetch(`${apiUrl}/jenis_tindakan_rad`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({})
        });
      } catch {
        resRad = await fetch(`${apiUrl}/jenis_tindakan_rad`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        });
      }

      if (resRad.ok) {
        const jsonRad = await resRad.json();
        // Extractor universal yang sangat agresif untuk mendukung semua format wrapper respon backend
        const rawRadJenis =
          jsonRad?.list_jenis_tindakan_rad ||
          jsonRad?.data?.list_jenis_tindakan_rad ||
          jsonRad?.data ||
          jsonRad?.jenis_tindakan_rad ||
          jsonRad?.response ||
          jsonRad?.result ||
          jsonRad?.list ||
          (Array.isArray(jsonRad) ? jsonRad : null);

        if (rawRadJenis && Array.isArray(rawRadJenis) && rawRadJenis.length > 0) {
          const names = rawRadJenis.map(j => typeof j === 'string' ? j : j.nmjenis || j.nm_jenis || j.nama_jenis || j.kategori).filter(Boolean);
          if (names.length > 0) setMasterJenisRadList(names);
        }
      }
    } catch (err) {
      console.warn('Endpoint /jenis_tindakan_rad offline:', err);
    }
  }, []);

  // ── Fetch Isi Paket Lab ──
  const handleViewIsiPaket = async (item) => {
    setSelectedPaketItem(item);
    setShowPaketModal(true);
    setIsLoadingPaket(true);
    setIsiPaketData([]);

    try {
      const apiUrl = getApiUrl();
      let res;
      try {
        res = await fetch(`${apiUrl}/isipaket_lab`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ kodepaket: item.kode })
        });
      } catch (e) {
        res = await fetch(`${apiUrl}/isipaket_lab?kodepaket=${item.kode}`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        });
      }

      if (res.ok) {
        const json = await res.json();
        const dataList = json?.list_isipaket_lab || json?.data || (Array.isArray(json) ? json : []);
        setIsiPaketData(dataList);
      }
    } catch (err) {
      console.error('Gagal mengambil isi paket:', err);
    } finally {
      setIsLoadingPaket(false);
    }
  };

  // Clock Effect & Fetch Initial Data
  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      setTime({
        date: now.toLocaleDateString('id-ID', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }),
        clock: now.toLocaleTimeString('id-ID') + ' WIB',
      });
    };
    updateTime();
    const interval = setInterval(updateTime, 1000);
    fetchTindakanLab();
    fetchTindakanRad();
    fetchJenisTindakan();
    return () => clearInterval(interval);
  }, [fetchTindakanLab, fetchTindakanRad, fetchJenisTindakan]);

  // Ekstrak daftar unik jenis laboratorium (nmjenis) dari endpoint /jenis_tindakan_lab & item list
  const uniqueJenisList = ['ALL', ...Array.from(new Set([
    ...masterJenisLabList.map(j => typeof j === 'string' ? j : j.nmjenis || j.nm_jenis || j.nama_jenis).filter(Boolean),
    ...tindakanLabList.map(item => item.nmjenis).filter(Boolean)
  ]))];

  // Ekstrak daftar unik jenis radiologi (nmjenis) dari endpoint /jenis_tindakan_rad & item list
  const uniqueRadJenisList = ['ALL', ...Array.from(new Set([
    ...masterJenisRadList.map(j => typeof j === 'string' ? j : j.nmjenis || j.nm_jenis || j.nama_jenis).filter(Boolean),
    ...tindakanRadList.map(item => item.nmjenis).filter(Boolean)
  ]))];

  // ── Filter Data Radiologi ──
  const filteredRadData = tindakanRadList.filter(item => {
    const q = searchQuery.toLowerCase().trim();
    const matchQuery =
      !q ||
      (item.kode || '').toLowerCase().includes(q) ||
      (item.nmjenis || '').toLowerCase().includes(q) ||
      (item.nmtindakan || '').toLowerCase().includes(q);

    const matchJenis = activeRadJenisTab === 'ALL' || (item.nmjenis || '').toUpperCase() === activeRadJenisTab.toUpperCase();

    return matchQuery && matchJenis;
  });

  const indexOfLastRad  = currentPage * itemsPerPage;
  const indexOfFirstRad = indexOfLastRad - itemsPerPage;
  const currentRadItems = filteredRadData.slice(indexOfFirstRad, indexOfLastRad);
  const totalRadPages   = Math.ceil(filteredRadData.length / itemsPerPage);

  // ── Filter Data Tindakan ──
  const filteredData = tindakanLabList.filter(item => {
    const q = searchQuery.toLowerCase().trim();
    const matchQuery =
      !q ||
      (item.kode || '').toLowerCase().includes(q) ||
      (item.kdjns || '').toLowerCase().includes(q) ||
      (item.nmjenis || '').toLowerCase().includes(q) ||
      (item.nmtindakan || '').toLowerCase().includes(q);

    const matchJenis = activeJenisTab === 'ALL' || (item.nmjenis || '').toUpperCase() === activeJenisTab.toUpperCase();

    let matchPaket = true;
    const isPaketItem = (item.paket === 1 || String(item.paket) === '1' || String(item.paket) === 'true' || (item.nm_paket && item.nm_paket.toLowerCase() === 'rincian tersendiri'));
    if (activePaketFilter === 'PAKET') {
      matchPaket = isPaketItem;
    } else if (activePaketFilter === 'NON_PAKET') {
      matchPaket = !isPaketItem;
    }

    return matchQuery && matchJenis && matchPaket;
  });

  // Pagination Logic
  const indexOfLast  = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirst, indexOfLast);
  const totalPages   = Math.ceil(filteredData.length / itemsPerPage);

  const handleOpenDetailModal = (item) => {
    setSelectedTindakan(item);
    setShowDetailModal(true);
  };

  const handleOpenAddModal = () => {
    setFormData({
      kdjns: '001',
      kode: `00${Math.floor(100 + Math.random() * 900)}`,
      nmjenis: activeJenisTab !== 'ALL' ? activeJenisTab : 'AUTOIMMUNE',
      nmtindakan: ''
    });
    setFormFeedback(null);
    setShowAddModal(true);
  };

  const handleAddSubmit = (e) => {
    e.preventDefault();
    if (!formData.nmtindakan.trim()) {
      setFormFeedback({ type: 'danger', text: 'Nama Tindakan / Pemeriksaan Lab wajib diisi!' });
      return;
    }

    const newItem = {
      kdjns: formData.kdjns,
      kode: formData.kode,
      nmjenis: formData.nmjenis.toUpperCase(),
      nmtindakan: formData.nmtindakan
    };

    setTindakanLabList(prev => [newItem, ...prev]);
    setFormFeedback({ type: 'success', text: 'Tindakan laboratorium berhasil ditambahkan!' });

    setTimeout(() => {
      setShowAddModal(false);
    }, 1200);
  };

  return (
    <div style={styles.appContainer}>
      {/* ══ NAVBAR HEADER COMPACT ══ */}
      <nav style={styles.navbarCustom} className="d-flex align-items-center justify-content-between text-white shadow-sm">
        <div className="d-flex align-items-center gap-2">
          <span className="fw-bold fs-6 tracking-wide d-flex align-items-center gap-2">
            <i className="bi bi-folder2-open text-warning fs-5"></i>
            SIMRS — Master Data Penunjang Medis
          </span>
        </div>
        <div className="d-flex align-items-center gap-3">
          <span className="text-light" style={{ fontSize: '0.72rem', opacity: 0.9 }}>
            <i className="bi bi-calendar-event me-1"></i>{time.date} |
            <i className="bi bi-clock me-1 ms-1"></i>{time.clock}
          </span>
          <Button
            variant="warning"
            size="sm"
            className="fw-semibold text-dark shadow-sm"
            style={{ padding: '0.2rem 0.75rem', fontSize: '0.75rem', borderRadius: '6px' }}
            onClick={() => navigate('/home')}
          >
            <i className="bi bi-house-door-fill me-1"></i> Kembali ke Home
          </Button>
        </div>
      </nav>

      {/* ══ MAIN CONTENT CONTAINER ══ */}
      <div style={styles.mainContent}>

        {/* ── Summary Stats Cards ── */}
        <Row className="g-2 mb-2">
          <Col md={4} sm={4}>
            <div style={{ background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '10px', padding: '0.55rem 0.8rem', display: 'flex', alignItems: 'center', gap: '0.65rem' }} className="shadow-sm">
              <div style={{ background: '#f0fdfa', color: '#0d9488', borderRadius: '8px', width: '38px', height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <i className="bi bi-journal-medical fs-5"></i>
              </div>
              <div>
                <div className="fw-bold" style={{ fontSize: '1.1rem', color: '#0f172a', lineHeight: 1.1 }}>{activeMainTab === 'lab' ? tindakanLabList.length : tindakanRadList.length}</div>
                <div className="text-muted" style={{ fontSize: '0.68rem' }}>{activeMainTab === 'lab' ? 'Total Pemeriksaan Lab' : 'Total Pemeriksaan Radiologi'}</div>
              </div>
            </div>
          </Col>

          <Col md={4} sm={4}>
            <div style={{ background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '10px', padding: '0.55rem 0.8rem', display: 'flex', alignItems: 'center', gap: '0.65rem' }} className="shadow-sm">
              <div style={{ background: '#f8fafc', color: '#0f172a', borderRadius: '8px', width: '38px', height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <i className="bi bi-tags-fill fs-5"></i>
              </div>
              <div>
                <div className="fw-bold" style={{ fontSize: '1.1rem', color: '#0f172a', lineHeight: 1.1 }}>{activeMainTab === 'lab' ? Math.max(uniqueJenisList.length - 1, 0) : Math.max(uniqueRadJenisList.length - 1, 0)}</div>
                <div className="text-muted" style={{ fontSize: '0.68rem' }}>Kategori / Jenis Penunjang</div>
              </div>
            </div>
          </Col>

          <Col md={4} sm={4}>
            <div style={{ background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '10px', padding: '0.55rem 0.8rem', display: 'flex', alignItems: 'center', gap: '0.65rem' }} className="shadow-sm">
              <div style={{ background: '#f0f9ff', color: '#0284c7', borderRadius: '8px', width: '38px', height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <i className="bi bi-check-circle-fill fs-5"></i>
              </div>
              <div>
                <div className="fw-bold" style={{ fontSize: '1.1rem', color: '#0f172a', lineHeight: 1.1 }}>{activeMainTab === 'lab' ? filteredData.length : filteredRadData.length}</div>
                <div className="text-muted" style={{ fontSize: '0.68rem' }}>Pemeriksaan Terfilter</div>
              </div>
            </div>
          </Col>
        </Row>

        {/* ── TAB NAVIGATION HEADER DATA PENUNJANG ── */}
        <Card className="border-0 shadow-sm mb-2" style={{ borderRadius: '10px', background: '#ffffff' }}>
          <Card.Header className="bg-white border-bottom-0 pb-0 pt-2 px-3">
            <Nav variant="tabs" defaultActiveKey="lab" onSelect={(k) => setActiveMainTab(k)}>
              <Nav.Item>
                <Nav.Link eventKey="lab" className="fw-bold text-teal d-flex align-items-center gap-1.5" style={{ fontSize: '0.8rem' }}>
                  <i className="bi bi-eyedropper text-teal" style={{ color: '#0d9488' }}></i>
                  <span>Daftar Pemeriksaan Laboratorium</span>
                  <Badge bg="teal" style={{ background: '#0d9488', fontSize: '0.65rem' }}>{tindakanLabList.length}</Badge>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="radiologi" className="fw-semibold text-secondary d-flex align-items-center gap-1.5" style={{ fontSize: '0.8rem' }}>
                  <i className="bi bi-x-ray"></i>
                  <span>Radiologi & Diagnostic Imaging</span>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="fisio" className="fw-semibold text-secondary d-flex align-items-center gap-1.5" style={{ fontSize: '0.8rem' }}>
                  <i className="bi bi-person-walking"></i>
                  <span>Fisioterapi & Rehab Medis</span>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="pa" className="fw-semibold text-secondary d-flex align-items-center gap-1.5" style={{ fontSize: '0.8rem' }}>
                  <i className="bi bi-virus"></i>
                  <span>Patologi Anatomi</span>
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Card.Header>

          {activeMainTab === 'lab' ? (
            <Card.Body className="p-3">
              {/* ── Sub-Tabs Filter Jenis Lab & Paket ── */}
              <div className="d-flex flex-wrap align-items-center gap-3 mb-3 pb-2" style={{ borderBottom: '1px solid #e2e8f0' }}>
                <div className="d-flex align-items-center gap-2">
                  <span className="text-muted fw-bold" style={{ fontSize: '0.72rem', whiteSpace: 'nowrap' }}>
                    <i className="bi bi-filter me-1"></i>JENIS LAB:
                  </span>
                  <Form.Select
                    size="sm"
                    style={{ fontSize: '0.75rem', width: 'auto', minWidth: '220px', borderRadius: '6px' }}
                    value={activeJenisTab}
                    onChange={e => { setActiveJenisTab(e.target.value); setCurrentPage(1); }}
                  >
                    {uniqueJenisList.map((jenis, idx) => (
                      <option key={idx} value={jenis}>
                        {jenis === 'ALL' ? 'Semua (ALL)' : jenis}
                      </option>
                    ))}
                  </Form.Select>
                </div>
                
                <div className="d-flex align-items-center gap-2 border-start ps-3">
                  <span className="text-muted fw-bold" style={{ fontSize: '0.72rem', whiteSpace: 'nowrap' }}>
                    <i className="bi bi-box-seam me-1"></i>KETERANGAN PAKET:
                  </span>
                  <Form.Select
                    size="sm"
                    style={{ fontSize: '0.75rem', width: 'auto', minWidth: '180px', borderRadius: '6px' }}
                    value={activePaketFilter}
                    onChange={e => { setActivePaketFilter(e.target.value); setCurrentPage(1); }}
                  >
                    <option value="ALL">Semua Data</option>
                    <option value="PAKET">Hanya Paket Pemeriksaan</option>
                    <option value="NON_PAKET">Bukan Paket (Reguler)</option>
                  </Form.Select>
                </div>
              </div>

              {/* ── Filter Controls (Search & Actions Bar) ── */}
              <Row className="g-2 mb-2 align-items-center">
                <Col md={3} sm={4}>
                  <Form.Select
                    size="sm"
                    value={itemsPerPage}
                    onChange={e => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); }}
                    style={{ fontSize: '0.78rem' }}
                  >
                    <option value={10}>10 Baris Per Halaman</option>
                    <option value={20}>20 Baris Per Halaman</option>
                    <option value={50}>50 Baris Per Halaman</option>
                    <option value={100}>100 Baris Per Halaman</option>
                    <option value={5000}>Tampilkan Semua Data ({tindakanLabList.length})</option>
                  </Form.Select>
                </Col>

                <Col md={6} sm={8}>
                  <InputGroup size="sm">
                    <InputGroup.Text style={{ background: '#f8fafc', fontSize: '0.78rem' }}>
                      <i className="bi bi-search text-muted"></i>
                    </InputGroup.Text>
                    <Form.Control
                      placeholder="Cari Kode (kode), Jenis (nmjenis), atau Nama Tindakan Lab (nmtindakan)..."
                      value={searchQuery}
                      onChange={e => { setSearchQuery(e.target.value); setCurrentPage(1); }}
                      style={{ fontSize: '0.78rem' }}
                    />
                    {searchQuery && (
                      <Button variant="outline-secondary" size="sm" onClick={() => setSearchQuery('')}>
                        ✕
                      </Button>
                    )}
                  </InputGroup>
                </Col>

                <Col md={3} sm={12} className="d-flex gap-1.5 justify-content-end">
                  <Button
                    variant="success"
                    size="sm"
                    className="fw-bold d-flex align-items-center gap-1 shadow-sm text-white"
                    style={{ fontSize: '0.73rem', background: '#059669', borderColor: '#059669', borderRadius: '6px' }}
                    onClick={handleOpenAddModal}
                  >
                    <i className="bi bi-plus-circle-fill"></i> Tambah Lab
                  </Button>
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={fetchTindakanLab}
                    disabled={isLoading}
                    style={{ fontSize: '0.73rem', borderRadius: '6px' }}
                  >
                    {isLoading ? <Spinner size="sm" animation="border" /> : <i className="bi bi-arrow-clockwise"></i>} Refresh
                  </Button>
                </Col>
              </Row>

              {fetchError && (
                <div className="alert alert-warning py-1 px-3 mb-2" style={{ fontSize: '0.75rem' }}>
                  <i className="bi bi-exclamation-triangle-fill me-1"></i>{fetchError}
                </div>
              )}

              {/* ── Table Utama: Daftar Pemeriksaan Laboratorium ── */}
              <div className="table-responsive border rounded" style={{ maxHeight: 'calc(100vh - 380px)', overflowY: 'auto' }}>
                <Table responsive hover striped bordered size="sm" className="align-middle mb-0" style={{ fontSize: '0.76rem' }}>
                  <thead style={{ background: '#0f172a', color: '#fff', position: 'sticky', top: 0, zIndex: 10 }}>
                    <tr>
                      <th className="text-center" style={{ width: '40px' }}>#</th>
                      <th className="text-center" style={{ width: '95px' }}>Kode (kode)</th>
                      <th className="text-center" style={{ width: '85px' }}>Kd Jenis</th>
                      <th className="text-center" style={{ width: '140px' }}>Kategori (nmjenis)</th>
                      <th>Nama Pemeriksaan Laboratorium (nmtindakan)</th>
                      <th className="text-center" style={{ width: '160px' }}>Nilai Rujukan / Normal</th>
                      <th className="text-center" style={{ width: '150px' }}>Keterangan Paket</th>
                      <th className="text-center" style={{ width: '105px' }}>LOINC Code</th>
                      <th className="text-center" style={{ width: '85px' }}>Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <tr>
                        <td colSpan="9" className="text-center py-4">
                          <Spinner animation="border" variant="teal" size="sm" className="me-2" style={{ color: '#0d9488' }} />
                          <span>Memuat data pemeriksaan laboratorium backend...</span>
                        </td>
                      </tr>
                    ) : currentItems.length > 0 ? (
                      currentItems.map((item, idx) => (
                        <tr key={idx}>
                          <td className="text-center text-muted">{indexOfFirst + idx + 1}</td>

                          {/* Kode Tindakan (kode) */}
                          <td className="text-center">
                            <Badge style={{ background: '#0f172a', fontSize: '0.72rem', fontWeight: '600' }} className="font-monospace text-white">
                              {item.kode}
                            </Badge>
                          </td>

                          {/* Kd Jenis (kdjns) */}
                          <td className="text-center">
                            <span className="fw-semibold font-monospace text-dark" style={{ fontSize: '0.76rem' }}>
                              {item.kdjns}
                            </span>
                          </td>

                          {/* Kategori / Jenis Lab (nmjenis) */}
                          <td className="text-center">
                            <span className="fw-bold text-dark" style={{ fontSize: '0.76rem' }}>
                              {item.nmjenis}
                            </span>
                          </td>

                          {/* Nama Pemeriksaan / Tindakan Lab (nmtindakan) */}
                          <td>
                            <div className="fw-bold text-dark" style={{ fontSize: '0.78rem' }}>
                              <i className="bi bi-eyedropper text-teal me-1.5" style={{ color: '#0d9488' }}></i>
                              {item.nmtindakan}
                            </div>
                            {item.satuan && (
                              <div className="text-muted" style={{ fontSize: '0.67rem' }}>
                                Satuan Hasil: <strong>{item.satuan}</strong>
                              </div>
                            )}
                          </td>

                          {/* Nilai Rujukan / Normal (nilainormal) */}
                          <td className="text-center">
                            <span className="fw-semibold text-dark font-monospace" style={{ fontSize: '0.75rem' }}>
                              {item.nilainormal || '—'}
                            </span>
                          </td>

                          {/* Keterangan Paket (nm_paket & paket) */}
                          <td className="text-center" style={{ fontSize: '0.72rem' }}>
                            <div className="fw-semibold text-dark">{item.nm_paket || '—'}</div>
                            {(item.paket === 1 || String(item.paket) === '1') && (
                              <Badge style={{ background: '#fef3c7', color: '#92400e', border: '1px solid #fde68a', fontSize: '0.62rem' }}>
                                Paket Pemeriksaan
                              </Badge>
                            )}
                          </td>

                          {/* LOINC Code */}
                          <td className="text-center font-monospace">
                            <span className="fw-semibold text-dark" style={{ fontSize: '0.76rem' }}>
                              {item.loinc_code || '—'}
                            </span>
                          </td>

                          {/* Aksi */}
                          <td className="text-center d-flex flex-column gap-1 align-items-center justify-content-center">
                            <Button
                              size="sm"
                              variant="outline-secondary"
                              style={{ padding: '0.15rem 0.45rem', fontSize: '0.7rem', borderRadius: '5px', borderColor: '#cbd5e1', color: '#0f172a', width: '100%' }}
                              onClick={() => handleOpenDetailModal(item)}
                            >
                              <i className="bi bi-eye-fill me-1"></i> Detail
                            </Button>
                            {(item.paket === 1 || String(item.paket) === '1' || String(item.paket) === 'true' || (item.nm_paket && item.nm_paket.toLowerCase() === 'rincian tersendiri')) && (
                              <Button
                                size="sm"
                                variant="outline-primary"
                                style={{ padding: '0.15rem 0.45rem', fontSize: '0.7rem', borderRadius: '5px', width: '100%' }}
                                onClick={() => handleViewIsiPaket(item)}
                              >
                                <i className="bi bi-box-seam me-1"></i> Isi Paket
                              </Button>
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="9" className="text-center py-4 text-muted">
                          Tidak ada data pemeriksaan laboratorium yang cocok.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>

              {/* ── Pagination Controls ── */}
              <div className="d-flex justify-content-between align-items-center mt-3 pt-2 border-top">
                <span className="text-muted" style={{ fontSize: '0.75rem' }}>
                  Menampilkan {filteredData.length > 0 ? indexOfFirst + 1 : 0} - {Math.min(indexOfLast, filteredData.length)} dari total {filteredData.length} data
                </span>
                {totalPages > 1 && (
                  <Pagination size="sm" className="mb-0 shadow-sm">
                    <Pagination.Prev onClick={() => setCurrentPage(p => Math.max(p - 1, 1))} disabled={currentPage === 1} />
                    {Array.from({ length: Math.min(totalPages, 15) }).map((_, i) => (
                      <Pagination.Item
                        key={i + 1}
                        active={i + 1 === currentPage}
                        onClick={() => setCurrentPage(i + 1)}
                      >
                        {i + 1}
                      </Pagination.Item>
                    ))}
                    {totalPages > 15 && <Pagination.Ellipsis disabled />}
                    <Pagination.Next onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages} />
                  </Pagination>
                )}
              </div>
            </Card.Body>
          ) : activeMainTab === 'radiologi' ? (
            <Card.Body className="p-3">
              {/* ── Sub-Tabs Filter Jenis Radiologi (nmjenis) ── */}
              <div className="d-flex align-items-center gap-2 mb-3 pb-2" style={{ borderBottom: '1px solid #e2e8f0' }}>
                <span className="text-muted fw-bold" style={{ fontSize: '0.72rem', whiteSpace: 'nowrap' }}>
                  <i className="bi bi-filter me-1"></i>JENIS RADIOLOGI:
                </span>
                <Form.Select
                  size="sm"
                  style={{ fontSize: '0.75rem', width: 'auto', minWidth: '220px', borderRadius: '6px' }}
                  value={activeRadJenisTab}
                  onChange={e => { setActiveRadJenisTab(e.target.value); setCurrentPage(1); }}
                >
                  {uniqueRadJenisList.map((jenis, idx) => (
                    <option key={idx} value={jenis}>
                      {jenis === 'ALL' ? 'Semua (ALL)' : jenis}
                    </option>
                  ))}
                </Form.Select>
              </div>

              {/* ── Filter Controls Radiologi ── */}
              <Row className="g-2 mb-2 align-items-center">
                <Col md={3} sm={4}>
                  <Form.Select
                    size="sm"
                    value={itemsPerPage}
                    onChange={e => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); }}
                    style={{ fontSize: '0.78rem' }}
                  >
                    <option value={10}>10 Baris Per Halaman</option>
                    <option value={20}>20 Baris Per Halaman</option>
                    <option value={50}>50 Baris Per Halaman</option>
                  </Form.Select>
                </Col>

                <Col md={6} sm={8}>
                  <InputGroup size="sm">
                    <InputGroup.Text style={{ background: '#f8fafc', fontSize: '0.78rem' }}>
                      <i className="bi bi-search text-muted"></i>
                    </InputGroup.Text>
                    <Form.Control
                      placeholder="Cari Kode Radiologi (kode), Jenis (nmjenis), atau Nama Tindakan (nmtindakan)..."
                      value={searchQuery}
                      onChange={e => { setSearchQuery(e.target.value); setCurrentPage(1); }}
                      style={{ fontSize: '0.78rem' }}
                    />
                    {searchQuery && (
                      <Button variant="outline-secondary" size="sm" onClick={() => setSearchQuery('')}>
                        ✕
                      </Button>
                    )}
                  </InputGroup>
                </Col>

                <Col md={3} sm={12} className="d-flex gap-1.5 justify-content-end">
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={fetchTindakanRad}
                    disabled={isLoadingRad}
                    style={{ fontSize: '0.73rem', borderRadius: '6px' }}
                  >
                    {isLoadingRad ? <Spinner size="sm" animation="border" /> : <i className="bi bi-arrow-clockwise"></i>} Refresh Radiologi
                  </Button>
                </Col>
              </Row>

              {/* ── Table Utama: Daftar Pemeriksaan Radiologi ── */}
              <div className="table-responsive border rounded" style={{ maxHeight: 'calc(100vh - 370px)', overflowY: 'auto' }}>
                <Table responsive hover striped bordered size="sm" className="align-middle mb-0" style={{ fontSize: '0.76rem' }}>
                  <thead style={{ background: '#0f172a', color: '#fff', position: 'sticky', top: 0, zIndex: 10 }}>
                    <tr>
                      <th className="text-center" style={{ width: '40px' }}>#</th>
                      <th className="text-center" style={{ width: '120px' }}>Kode (kode)</th>
                      <th className="text-center" style={{ width: '180px' }}>Kategori / Jenis Radiologi (nmjenis)</th>
                      <th>Nama Pemeriksaan Radiologi (nmtindakan)</th>
                      <th className="text-center" style={{ width: '90px' }}>Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoadingRad ? (
                      <tr>
                        <td colSpan="5" className="text-center py-4">
                          <Spinner animation="border" variant="teal" size="sm" className="me-2" style={{ color: '#0d9488' }} />
                          <span>Memuat data pemeriksaan radiologi backend...</span>
                        </td>
                      </tr>
                    ) : currentRadItems.length > 0 ? (
                      currentRadItems.map((item, idx) => (
                        <tr key={idx}>
                          <td className="text-center text-muted">{indexOfFirstRad + idx + 1}</td>

                          {/* Kode Tindakan Radiologi */}
                          <td className="text-center">
                            <Badge style={{ background: '#0f172a', fontSize: '0.72rem', fontWeight: '600' }} className="font-monospace text-white">
                              {item.kode}
                            </Badge>
                          </td>

                          {/* Kategori / Jenis Radiologi (nmjenis) */}
                          <td className="text-center">
                            <span className="fw-bold text-dark" style={{ fontSize: '0.76rem' }}>
                              {item.nmjenis}
                            </span>
                          </td>

                          {/* Nama Pemeriksaan Radiologi (nmtindakan) */}
                          <td>
                            <div className="fw-bold text-dark" style={{ fontSize: '0.78rem' }}>
                              <i className="bi bi-x-ray text-teal me-1.5" style={{ color: '#0d9488' }}></i>
                              {item.nmtindakan}
                            </div>
                          </td>

                          {/* Aksi */}
                          <td className="text-center">
                            <Button
                              size="sm"
                              variant="outline-secondary"
                              style={{ padding: '0.15rem 0.45rem', fontSize: '0.7rem', borderRadius: '5px', borderColor: '#cbd5e1', color: '#0f172a' }}
                              onClick={() => handleOpenDetailModal(item)}
                            >
                              <i className="bi bi-eye-fill me-1"></i> Detail
                            </Button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center py-4 text-muted">
                          Tidak ada data pemeriksaan radiologi yang cocok.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>

              {/* ── Pagination Controls Radiologi ── */}
              <div className="d-flex justify-content-between align-items-center mt-3 pt-2 border-top">
                <span className="text-muted" style={{ fontSize: '0.75rem' }}>
                  Menampilkan {filteredRadData.length > 0 ? indexOfFirstRad + 1 : 0} - {Math.min(indexOfLastRad, filteredRadData.length)} dari total {filteredRadData.length} data
                </span>
                {totalRadPages > 1 && (
                  <Pagination size="sm" className="mb-0 shadow-sm">
                    <Pagination.Prev onClick={() => setCurrentPage(p => Math.max(p - 1, 1))} disabled={currentPage === 1} />
                    {Array.from({ length: Math.min(totalRadPages, 15) }).map((_, i) => (
                      <Pagination.Item
                        key={i + 1}
                        active={i + 1 === currentPage}
                        onClick={() => setCurrentPage(i + 1)}
                      >
                        {i + 1}
                      </Pagination.Item>
                    ))}
                    {totalRadPages > 15 && <Pagination.Ellipsis disabled />}
                    <Pagination.Next onClick={() => setCurrentPage(p => Math.min(p + 1, totalRadPages))} disabled={currentPage === totalRadPages} />
                  </Pagination>
                )}
              </div>
            </Card.Body>
          ) : (
            <Card.Body className="p-4 text-center text-muted">
              <i className="bi bi-info-circle display-5 mb-2"></i>
              <div className="fw-bold text-dark" style={{ fontSize: '0.9rem' }}>Modul Penunjang Medis Dalam Pengembangan</div>
              <div style={{ fontSize: '0.75rem' }}>Silakan beralih ke tab <strong>Daftar Pemeriksaan Laboratorium</strong> atau <strong>Radiologi</strong>.</div>
            </Card.Body>
          )}
        </Card>
      </div>

      {/* ══ MODAL DETAIL TINDAKAN LAB ══ */}
      <Modal show={showDetailModal} onHide={() => setShowDetailModal(false)} centered size="md">
        <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 60%, #0d9488 100%)', color: '#fff' }}>
          <Modal.Title style={{ fontSize: '0.88rem', fontWeight: '700' }} className="d-flex align-items-center gap-2">
            <i className="bi bi-info-circle-fill text-warning"></i>
            <span>DETAIL PEMERIKSAAN LABORATORIUM</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 bg-white">
          {selectedTindakan && (
            <Row className="g-2.5" style={{ fontSize: '0.78rem' }}>
              <Col md={6}>
                <div className="text-muted" style={{ fontSize: '0.68rem' }}>Kode Tindakan (kode)</div>
                <div className="fw-bold font-monospace text-dark fs-6">{selectedTindakan.kode}</div>
              </Col>
              <Col md={6}>
                <div className="text-muted" style={{ fontSize: '0.68rem' }}>Kode Jenis (kdjns)</div>
                <div className="fw-bold font-monospace text-teal" style={{ color: '#0d9488' }}>{selectedTindakan.kdjns}</div>
              </Col>
              <Col md={6}>
                <div className="text-muted" style={{ fontSize: '0.68rem' }}>Kategori / Jenis Lab (nmjenis)</div>
                <Badge bg="teal" style={{ background: '#0d9488', fontSize: '0.75rem' }} className="mt-0.5">
                  {selectedTindakan.nmjenis}
                </Badge>
              </Col>
              <Col md={6}>
                <div className="text-muted" style={{ fontSize: '0.68rem' }}>LOINC Code</div>
                <div className="fw-bold font-monospace text-primary">{selectedTindakan.loinc_code || '—'}</div>
              </Col>
              <Col md={12} className="border-top pt-2 mt-2">
                <div className="text-muted" style={{ fontSize: '0.68rem' }}>Nama Pemeriksaan / Tindakan Laboratorium (nmtindakan)</div>
                <div className="fw-bold text-dark fs-6">{selectedTindakan.nmtindakan}</div>
              </Col>
              <Col md={12}>
                <div className="text-muted" style={{ fontSize: '0.68rem' }}>Nilai Rujukan / Normal (nilainormal)</div>
                <div className="fw-bold text-dark font-monospace" style={{ fontSize: '0.88rem', color: '#0d9488' }}>{selectedTindakan.nilainormal || '—'}</div>
              </Col>
              <Col md={6}>
                <div className="text-muted" style={{ fontSize: '0.68rem' }}>Keterangan Paket (nm_paket)</div>
                <div className="fw-semibold text-dark">{selectedTindakan.nm_paket || '—'}</div>
              </Col>
              <Col md={6}>
                <div className="text-muted" style={{ fontSize: '0.68rem' }}>Satuan Hasil</div>
                <div className="fw-semibold text-dark">{selectedTindakan.satuan || '—'}</div>
              </Col>
            </Row>
          )}
        </Modal.Body>
        <Modal.Footer className="py-1 px-3 bg-light border-top">
          <Button variant="secondary" size="sm" onClick={() => setShowDetailModal(false)}>
            Tutup
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ══ MODAL TAMBAH TINDAKAN LAB ══ */}
      <Modal show={showAddModal} onHide={() => setShowAddModal(false)} centered size="md">
        <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 60%, #0d9488 100%)', color: '#fff' }}>
          <Modal.Title style={{ fontSize: '0.88rem', fontWeight: '700' }} className="d-flex align-items-center gap-2">
            <i className="bi bi-plus-circle-fill text-warning"></i>
            <span>TAMBAH PEMERIKSAAN LABORATORIUM BARU</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 bg-white">
          <Form onSubmit={handleAddSubmit}>
            {formFeedback && (
              <div className={`alert alert-${formFeedback.type} py-1.5 px-3 mb-2`} style={{ fontSize: '0.75rem' }}>
                {formFeedback.text}
              </div>
            )}
            <Row className="g-2">
              <Col md={6}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-semibold text-dark mb-0.5" style={{ fontSize: '0.72rem' }}>Kode Jenis (kdjns)</Form.Label>
                  <Form.Control
                    type="text"
                    size="sm"
                    value={formData.kdjns}
                    onChange={e => setFormData({ ...formData, kdjns: e.target.value })}
                    required
                    style={{ fontSize: '0.78rem' }}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-semibold text-dark mb-0.5" style={{ fontSize: '0.72rem' }}>Kode Tindakan (kode)</Form.Label>
                  <Form.Control
                    type="text"
                    size="sm"
                    value={formData.kode}
                    onChange={e => setFormData({ ...formData, kode: e.target.value })}
                    required
                    style={{ fontSize: '0.78rem' }}
                  />
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-semibold text-dark mb-0.5" style={{ fontSize: '0.72rem' }}>Kategori / Jenis Lab (nmjenis)</Form.Label>
                  <Form.Control
                    type="text"
                    size="sm"
                    value={formData.nmjenis}
                    onChange={e => setFormData({ ...formData, nmjenis: e.target.value })}
                    placeholder="Contoh: AUTOIMMUNE / TUMOR MARKER / HEMATOLOGI"
                    required
                    style={{ fontSize: '0.78rem' }}
                  />
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-semibold text-dark mb-0.5" style={{ fontSize: '0.72rem' }}>Nama Pemeriksaan / Tindakan Lab (nmtindakan)</Form.Label>
                  <Form.Control
                    type="text"
                    size="sm"
                    value={formData.nmtindakan}
                    onChange={e => setFormData({ ...formData, nmtindakan: e.target.value })}
                    placeholder="Contoh: ACA IgG (Elisa)"
                    required
                    style={{ fontSize: '0.78rem' }}
                  />
                </Form.Group>
              </Col>
            </Row>
            <div className="d-flex justify-content-end gap-2 border-top pt-2 mt-3">
              <Button variant="light" size="sm" onClick={() => setShowAddModal(false)}>Batal</Button>
              <Button type="submit" variant="teal" size="sm" className="fw-bold text-white px-3" style={{ background: '#0d9488', borderColor: '#0d9488' }}>
                <i className="bi bi-save me-1"></i> Simpan Data Lab
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* ── Modal Detail Isi Paket Lab ── */}
      <Modal show={showPaketModal} onHide={() => setShowPaketModal(false)} size="lg" centered backdrop="static">
        <Modal.Header closeButton style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
          <Modal.Title className="fw-bold text-dark d-flex align-items-center gap-2" style={{ fontSize: '1.1rem' }}>
            <i className="bi bi-box-seam text-primary"></i>
            Isi Paket Pemeriksaan
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3">
          {selectedPaketItem && (
            <div className="mb-3 px-2">
              <h6 className="fw-bold text-dark mb-1">{selectedPaketItem.nmtindakan}</h6>
              <span className="text-muted" style={{ fontSize: '0.8rem' }}>Kode Paket: <strong>{selectedPaketItem.kode}</strong></span>
            </div>
          )}

          {isLoadingPaket ? (
            <div className="text-center py-5">
              <Spinner animation="border" variant="primary" size="sm" className="me-2" />
              <span className="text-muted" style={{ fontSize: '0.85rem' }}>Memuat rincian paket...</span>
            </div>
          ) : isiPaketData.length > 0 ? (
            <div className="table-responsive border rounded shadow-sm" style={{ maxHeight: '400px', overflowY: 'auto' }}>
              <Table responsive hover striped bordered size="sm" className="align-middle mb-0" style={{ fontSize: '0.75rem' }}>
                <thead style={{ background: '#0f172a', color: '#fff', position: 'sticky', top: 0, zIndex: 10 }}>
                  <tr>
                    <th className="text-center" style={{ width: '40px' }}>#</th>
                    <th className="text-center" style={{ width: '80px' }}>Kode</th>
                    <th>Nama Pemeriksaan</th>
                    <th className="text-center">Nilai Rujukan (L/P/Anak)</th>
                    <th className="text-center">Satuan</th>
                  </tr>
                </thead>
                <tbody>
                  {isiPaketData.map((pkt, idx) => (
                    <tr key={idx}>
                      <td className="text-center text-muted">{idx + 1}</td>
                      <td className="text-center">
                        <Badge bg="secondary" className="font-monospace">{pkt.kode}</Badge>
                      </td>
                      <td className="fw-semibold text-dark">{pkt.nmtindakan}</td>
                      <td className="text-center font-monospace text-muted" style={{ fontSize: '0.7rem' }}>
                        <div>L: {pkt.nilaip || '-'} s/d {pkt.nilaip1 || '-'}</div>
                        <div>P: {pkt.nilaiw || '-'} s/d {pkt.nilaiw1 || '-'}</div>
                        <div>Anak: {pkt.nilaia || '-'} s/d {pkt.nilaia1 || '-'}</div>
                      </td>
                      <td className="text-center fw-semibold">{pkt.satuan || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : (
            <div className="text-center py-4 text-muted">
              <i className="bi bi-inbox fs-2 text-secondary mb-2 d-block"></i>
              Data rincian paket tidak ditemukan atau paket kosong.
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="bg-light p-2 border-top-0 justify-content-end">
          <Button variant="secondary" size="sm" onClick={() => setShowPaketModal(false)}>Tutup</Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
};

const styles = {
  appContainer: {
    minHeight: '100vh',
    backgroundColor: '#f8fafc',
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  navbarCustom: {
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 60%, #0d9488 100%)',
    padding: '0.45rem 1rem',
    borderBottom: '2px solid #0d9488'
  },
  mainContent: {
    padding: '0.65rem 0.85rem'
  }
};

export default DataPenunjang;
